import { Outlet } from 'react-router'

import { usePreferencesSync } from '../features/preferences/use-preferences'

/** Raiz das rotas: aplica tema e densidade do usuário e renderiza a rota atual. */
export function RootLayout() {
  usePreferencesSync()
  return <Outlet />
}
